@if (error == null) {
  <div>
    @if (loading) {
      <kendo-loader type="converging-spinner" size="small"></kendo-loader>
    } @else {
      <p>
        To create a new Schedule and its Activities for Project <strong>{{projectId()}}</strong>, click <strong>Create Schedule</strong>.
        Ensure you've tried <strong>Find Schedule</strong> first.
      </p>
      <p>
        Refresh your browser to update the Schedule tab. Note that the scheduled dates may initially be incorrect and may need manual adjustments.
      </p>
    }
  </div>
} @else {
  <div class="alert alert-danger d-flex align-items-center" role="alert">
    <kendo-svgicon [icon]="icons.warning" class="me-2"></kendo-svgicon>
    <div>
      {{ error }}
    </div>
  </div>
}
<kendo-dialog-actions class="ps-0 pe-0 border-0">
  <button type="button" kendoButton (click)="onCloseDialog()">Cancel</button>
  <button type="button" kendoButton themeColor="primary" (click)="createSchedule()" [disabled]="loading || error != null">Create Schedule</button>
</kendo-dialog-actions>